import useCookieStatusStore from '@state/CookieStatusStore';
import { useEffect } from 'react';

const useCookieConsent = () => {
  const { setCookieStatus } = useCookieStatusStore((state) => ({
    setCookieStatus: state.setCookieStatus,
  }));

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (window.OnetrustActiveGroups) {
        setCookieStatus(
          window.OnetrustActiveGroups.split(',').slice(1).length > 2
        );
        clearInterval(intervalId);
      }
    }, 100);

    return () => clearInterval(intervalId);
  }, [setCookieStatus]);

  useEffect(() => {
    window.OptanonWrapper = () => {
      if (
        window.OneTrust &&
        typeof window.OneTrust.OnConsentChanged === 'function'
      ) {
        window.OneTrust.OnConsentChanged((e) => {
          setCookieStatus(e.detail.length > 1);
        });
      }
    };
  }, [setCookieStatus]);
};

export default useCookieConsent;
